import * as yup from "yup";
import {regEx_username} from "../../global/global";

//RegEx
export const passwordRegEx = /^.*(?=.{6,})(?=.*[a-zA-Z])(?=.*\d).*$/;

//schemas
export const loginSchema = yup.object().shape({
  username: yup
    .string()
    .matches(regEx_username, "Ikke gyldig epost")
    .required("Vennligst fyll in mobil/epost"),
  password: yup
    .string()
    .min(6, "Passord for kort")
    .max(60, "Passord for langt")
    .required("Vennligst fyll inn ditt passord"),
});
export type loginProps = yup.InferType<typeof loginSchema>;
